import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer__row" }
const _hoisted_4 = { class: "footer__social-wrapper" }
const _hoisted_5 = { class: "footer__social" }
const _hoisted_6 = { class: "footer__copyright" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Minden jog fenntartva. ")
const _hoisted_9 = {
  key: 0,
  class: "footer__lists"
}
const _hoisted_10 = { class: "footer__list" }
const _hoisted_11 = {
  key: 1,
  class: "footer__app"
}
const _hoisted_12 = {
  key: 2,
  class: "footer-bottom footer-bottom--mobile"
}
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "footer-bottom__list" }
const _hoisted_15 = { class: "footer-bottom__list-item" }
const _hoisted_16 = {
  key: 0,
  class: "footer-bottom footer-bottom--desktop"
}
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "footer-bottom__list" }
const _hoisted_19 = { class: "footer-bottom__list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_footer_logo = _resolveComponent("footer-logo")!
  const _component_facebook_full = _resolveComponent("facebook-full")!
  const _component_nav_link = _resolveComponent("nav-link")!
  const _component_instagram = _resolveComponent("instagram")!
  const _component_twitter = _resolveComponent("twitter")!
  const _component_social_media_links = _resolveComponent("social-media-links")!
  const _component_arrow_up = _resolveComponent("arrow-up")!
  const _component_google_play = _resolveComponent("google-play")!
  const _component_app_store = _resolveComponent("app-store")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_footer_logo),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_social_media_links, null, {
                default: _withCtx(({ facebook, instagram, twitter }) => [
                  facebook
                    ? (_openBlock(), _createBlock(_component_nav_link, {
                        key: 0,
                        to: facebook,
                        target: "_blank",
                        class: "footer__social-item",
                        "aria-label": "Facebook oldal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_facebook_full, { "aria-hidden": "true" })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  instagram
                    ? (_openBlock(), _createBlock(_component_nav_link, {
                        key: 1,
                        to: instagram,
                        target: "_blank",
                        class: "footer__social-item",
                        "aria-label": "Instagram oldal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_instagram, { "aria-hidden": "true" })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  twitter
                    ? (_openBlock(), _createBlock(_component_nav_link, {
                        key: 2,
                        to: twitter,
                        target: "_blank",
                        class: "footer__social-item",
                        "aria-label": "Twotter oldal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_twitter, { "aria-hidden": "true" })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.date) + " © RTL Magyarország. ", 1),
              _hoisted_7,
              _hoisted_8
            ])
          ]),
          (_ctx.menu.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.footer.menuItems, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "footer__list-item",
                      key: item.id
                    }, [
                      _createVNode(_component_nav_link, {
                        to: item.targetUrl,
                        target: item.target,
                        class: "footer__list-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "target"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: "#",
            class: "footer__back-to-top",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToTop && _ctx.goToTop(...args)), ["prevent"])),
            "aria-label": "Ugrás az oldal tetejére"
          }, [
            _createVNode(_component_arrow_up, { "aria-hidden": "true" })
          ]),
          (_ctx.androidAppUrl || _ctx.iosAppUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.androidAppUrl)
                  ? (_openBlock(), _createBlock(_component_nav_link, {
                      key: 0,
                      to: _ctx.androidAppUrl,
                      target: "_blank",
                      class: "footer__list-link"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_google_play)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.iosAppUrl)
                  ? (_openBlock(), _createBlock(_component_nav_link, {
                      key: 1,
                      to: _ctx.iosAppUrl,
                      target: "_blank",
                      class: "footer__list-link"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_app_store)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.menu.footerBase)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.footerBase.menuItems, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "footer-bottom__list-item",
                        key: item.id
                      }, [
                        _createVNode(_component_nav_link, {
                          to: item.targetUrl,
                          target: item.target,
                          class: "footer-bottom__list-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "target"])
                      ]))
                    }), 128)),
                    _createElementVNode("li", _hoisted_15, [
                      _createElementVNode("span", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCookieBox())),
                        class: "footer-bottom__list-link"
                      }, "Süti beállítások")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.menu.footerBase)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("ul", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.footerBase.menuItems, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "footer-bottom__list-item",
                  key: item.id
                }, [
                  _createVNode(_component_nav_link, {
                    to: item.targetUrl,
                    target: item.target,
                    class: "footer-bottom__list-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "target"])
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_19, [
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCookieBox())),
                  class: "footer-bottom__list-link"
                }, "Süti beállítások")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}